var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import ELogisticsType from '../../../enum/ELogisticsType';
import EHandleStatus from '../../../enum/EHandleStatus';
import { Prop, Watch } from 'vue-property-decorator';
import { summaries } from '../../../helper/util';
import { numAdd, numSub, numMulti, numDiv } from '../../../helper/calucate';
import GoodsStockService from '../../../api/GoodsStockService';
import BasicArcheivesService from '../../../api/BasicArcheivesService';
import GLOBAL_VUE from '../../../globalVue';
import _ from 'lodash';
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import EOrderFromSystem from '../../../enum/EOrderFromSystem';
import { EPurOrderErrorCode } from "../../../enum/EPurchaseOrderCode";
import CommonService from '../../../api/CommonService';
import DistriDialog from './DistributionDialog.vue';
import SeeBindLicenses from '../../good/SeeBindLicenses';
import ArticleList from "../../../components/alert/ArticleList.vue";
import ArtMsglist from "../../../components/alert/ArtMsglist.vue";
import Client from '../../client/List.vue';
import Purchase from '../../purchase/List.vue';
import addGoods from "./ReplaceGoods/AddGoods.vue";
import { BigNumber } from "bignumber.js";
export var EOrderType;
(function (EOrderType) {
    EOrderType[EOrderType["ORDER"] = 0] = "ORDER";
    EOrderType[EOrderType["NO_ORDER"] = 1] = "NO_ORDER";
    EOrderType[EOrderType["RETAIL"] = 2] = "RETAIL";
})(EOrderType || (EOrderType = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.from_system = 3;
        _this.eOrderFromSystem = EOrderFromSystem;
        _this.eLogisticsType = ELogisticsType;
        _this.orderHasMerge = false;
        _this.loadingOutDepotOptions = false;
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            }
        };
        _this.enumStatus = EHandleStatus;
        _this.EOrderType = EOrderType;
        _this.goods_ids = [];
        _this.goodsTableData = _this.data || [];
        _this.order_id = 0;
        _this.mulShopList = [];
        _this.mulOrderDetailRowData = {};
        _this.currentGood = {};
        _this.changeDepotmodalShow = false;
        _this.depotList = [];
        _this.changeDepotId = '';
        _this.shipData = '';
        _this.selectGood = [];
        return _this;
    }
    default_1.prototype.dataChange = function (val, oldVal) {
        this.goodsTableData = val || [];
        if (this.goodsTableData.length !== (oldVal || []).length) {
            this.$refs.Table.doLayout();
        }
    };
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
        this.$emit('selection-change', this.selections);
    };
    default_1.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.goodsStockService = GoodsStockService.getInstance();
        this.basicArcheivesService = BasicArcheivesService.getInstance();
    };
    default_1.prototype.changeDepotmodalConfirm = function () {
        var _this = this;
        if (!this.changeDepotId)
            return this.$message.warning('请选择出库仓库');
        this.selections.map(function (item) {
            var index = _this.goodsTableData.indexOf(item);
            GLOBAL_VUE.$set(_this.goodsTableData[index], 'outDepotOptions', _this.depotList);
            GLOBAL_VUE.$set(_this.goodsTableData[index], 'out_depot_id', _this.changeDepotId);
        });
        this.changeDepotmodalHide();
        this.$refs.Table.clearSelection();
    };
    default_1.prototype.changeDepot = function () {
        if (!this.formData.organ_id)
            return this.$message.warning('请选择出库机构');
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请先选择货品');
            return;
        }
        this.getDepotList();
        this.changeDepotmodalShow = true;
    };
    default_1.prototype.getDepotList = function (callBack) {
        var _this = this;
        var params = {
            is_init: 1,
            organ_id: this.formData.organ_id,
        };
        this.commonService.getDepotList(params).then(function (res) {
            var data = Array.isArray(res.data.data) ? res.data.data : [];
            _this.depotList = data;
            callBack && callBack();
        });
    };
    default_1.prototype.changeDepotmodalHide = function () {
        this.changeDepotmodalShow = false;
        this.changeDepotId = '';
    };
    default_1.prototype.selectStockBatch = function (row) {
        this.$emit('selectStockBatch', row);
    };
    default_1.prototype.batchSubmit = function (row) {
        if (row.batch_list.length) {
            var order_detail_oamount_1 = 0;
            var productionDateList = row.batch_list.map(function (item) { return item.production_date; });
            productionDateList.sort(function (a, b) {
                return moment(a).isBefore(b) ? -1 : 1;
            });
            row.production_date = productionDateList[0];
            row.batch_list.map(function (item) {
                order_detail_oamount_1 = numAdd(order_detail_oamount_1, item.order_detail_oamount);
            });
            row.order_detail_oamount = order_detail_oamount_1.toFixedNoZero(4);
        }
        else {
            row.order_detail_oamount = row.old_order_detail_oamount || 0;
        }
        console.log('batchSubmit', row);
    };
    default_1.prototype.calc_stock = function (row) {
        return "" + row.order_remaining_stock + row.inventory_unit;
    };
    default_1.prototype.calc_deliveryVolume = function (row) {
        return numMulti(numAdd(row.order_detail_oamount || 0, row.order_gift_oamount || 0), row.sales_unit_coefficient).toFixedNoZero(4);
    };
    default_1.prototype.calc_amountIncludingTaxscope = function (row, type) {
        return (row[type] = numMulti(row.order_detail_oamount, row.order_detail_uprice).toFixedNoZero(4));
    };
    default_1.prototype.calc_taxAmount = function (row, type) {
        if (row.order_detail_tax_rate === 0) {
            return (row[type] = 0);
        }
        if (this.handleStatus === EHandleStatus.Edit) {
            var shifuMoney = numSub((row.order_detail_goods_money || 0), (row.order_detail_reduction_money || 0));
            var shuieMoney = numMulti(numDiv(shifuMoney, numAdd(1, row.order_detail_tax_rate)), row.order_detail_tax_rate);
            return (row[type] = shuieMoney.toFixedNoZero(4));
        }
        else {
            var firArg = numMulti(row.order_detail_oamount, row.order_detail_uprice);
            var secArg = numAdd(1, row.order_detail_tax_rate);
            return (row[type] = numMulti(numDiv(firArg, secArg), row.order_detail_tax_rate).toFixedNoZero(4));
        }
    };
    default_1.prototype.calc_amountOfMoney = function (row, type) {
        return (row[type] = numSub(row.order_detail_goods_money || 0, row.order_detail_reduction_money || 0).toFixedNoZero(4));
    };
    default_1.prototype.calc_amountOfGoodsMoney = function (row, type) {
        if (this.handleStatus === EHandleStatus.Edit) {
            var shifuMoney = numSub(row.order_detail_goods_money || 0, row.order_detail_reduction_money || 0);
            var shuieMoney = numMulti(numDiv(shifuMoney, numAdd(1, row.order_detail_tax_rate)), row.order_detail_tax_rate);
            return (row[type] = numSub(shifuMoney, shuieMoney).toFixedNoZero(4));
        }
        else {
            var amountIncludingTaxs = numMulti(row.order_detail_oamount, row.order_detail_uprice);
            if (row.order_detail_tax_rate === 0) {
                amountIncludingTaxs.toFixedNoZero(4);
            }
            var taxRateAmount = numDiv(amountIncludingTaxs, numAdd(1, row.order_detail_tax_rate));
            var taxAmount = numMulti(taxRateAmount, row.order_detail_tax_rate);
            return (row[type] = numSub(amountIncludingTaxs, taxAmount).toFixedNoZero(4));
        }
    };
    default_1.prototype.dealManyShopAmount = function (row, index) {
        console.log('emit dealManyShopAmount>>>', row, index);
        this.$emit('show-more', row, index, this.goodsTableData);
    };
    default_1.prototype.blur_priceAndamount = function (data, name) {
        if (data[name] == '') {
            data[name] = 0;
        }
    };
    default_1.prototype.myFixed = function (num, digit) {
        return BigNumber(num).toFixed(digit);
    };
    default_1.prototype.blurInputChange = function (row, key) {
        if (key === 'order_detail_goods_money' || key === 'upper_warehouse_uprice')
            row[key] = new Number(row[key]).toFixedNoZero(2);
    };
    default_1.prototype.inputChange = function (row, key) {
        if ((key === 'order_detail_oamount' || key === 'order_gift_oamount') && row[key]) {
            var pointIndex = String(row[key]).indexOf('.');
            if (pointIndex > -1) {
                row[key] = String(row[key]).slice(0, pointIndex + Number(this.amountScale) + 1);
            }
        }
        else if (row[key]) {
            row[key] = String(row[key]).replace(/^(.*\..{4}).*$/, "$1");
        }
        if ((key === 'order_detail_uprice' || key === 'order_detail_goods_money') && parseFloat(row.order_detail_oamount)) {
            if (key === 'order_detail_uprice') {
                row['order_detail_goods_money'] = new Number(_.multiply(row.order_detail_uprice, row.order_detail_oamount)).toFixedNoZero(2);
            }
            else {
                row['order_detail_uprice'] = this.myFixed((row.order_detail_goods_money / row.order_detail_oamount), 4);
            }
        }
        if (key === 'order_detail_oamount' && (parseFloat(row.order_detail_uprice) || parseFloat(row.order_detail_goods_money))) {
            row.batch_list = [];
            if (parseFloat(row.order_detail_uprice)) {
                row['order_detail_goods_money'] = new Number(_.multiply(row.order_detail_oamount, row.order_detail_uprice)).toFixedNoZero(2);
            }
            else {
                row['order_detail_uprice'] = this.myFixed((row.order_detail_goods_money / row.order_detail_oamount), 4);
            }
        }
        this.calc_amountOfMoney(row, 'order_detail_money');
    };
    default_1.prototype.outDepotChange = function (row) {
        var _this = this;
        row.batch_list = [];
        if (this.openedCodeData && this.openedCodeData.isOpenERP) {
            var params = {
                depot_id: row.out_depot_id,
                goods_format_id: row.goods_format_id,
            };
            return this.goodsStockService
                .getDepotGoodsFormatStock(params)
                .then(function (res) {
                var data = res.data.data;
                row.order_remaining_stock = data.order_remaining_stock;
                row.production_date = data.production_date;
            })
                .catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
    };
    default_1.prototype.resetOutDepotOptions = function () {
        var _this = this;
        var CALL_BACK = function () {
            var defaultDepotId = '';
            var defaultDepotName = '';
            _this.depotList.some(function (item) {
                if (item.is_organ_default == 1) {
                    defaultDepotId = item.depot_id;
                    defaultDepotName = item.depot_name;
                }
            });
            _this.goodsTableData.forEach(function (row) {
                row.out_depot_id = defaultDepotId;
                row.out_depot_name = defaultDepotName;
                if (row.items && row.items.length) {
                    row.items.map(function (item) {
                        item.out_depot_id = defaultDepotId;
                        item.out_depot_name = defaultDepotName;
                    });
                }
                _this.getOutDepotOptionsOneOrZero(row);
            });
        };
        this.getDepotList(CALL_BACK);
    };
    default_1.prototype.initOutDepotOptions = function () {
        var _this = this;
        this.goodsTableData.forEach(function (row) {
            row.out_depot_id = row.out_depot_id == 0 ? '' : row.out_depot_id;
            _this.getOutDepotOptionsOneOrZero(row);
        });
    };
    default_1.prototype.filterSearch = function (val, row) {
        var _this = this;
        clearTimeout(this.time);
        this.time = setTimeout(function () {
            _this.getOutDepotOptions(val, row);
        }, 500);
    };
    default_1.prototype.focusOutDepotId = function (event, row) {
        this.getOutDepotOptions('', row);
    };
    default_1.prototype.getOutDepotOptions = function (val, row) {
        var _this = this;
        var params = {
            is_init: 1,
            organ_id: this.formData.organ_id,
        };
        this.loadingOutDepotOptions = true;
        this.commonService
            .getDepotList(params)
            .then(function (res) {
            if (res.data.success) {
                var data = res.data.data || [];
                var index = void 0;
                if (row.isIndex) {
                    index = _this.goodsTableData.indexOf(row);
                }
                else {
                    row.outDepotOptions = data;
                }
                GLOBAL_VUE.$set(_this.goodsTableData[index], 'outDepotOptions', data);
            }
            _this.loadingOutDepotOptions = false;
        })
            .catch(function () {
            _this.loadingOutDepotOptions = false;
        });
    };
    default_1.prototype.getOutDepotOptionsOneOrZero = function (row, trigger) {
        var data = [];
        if (row.out_depot_id) {
            data.push({
                depot_id: row.out_depot_id,
                depot_name: row.out_depot_name,
            });
        }
        var index = this.goodsTableData.indexOf(row);
        GLOBAL_VUE.$set(this.goodsTableData[index], 'outDepotOptions', data);
    };
    default_1.prototype.updateDeliveryOrder = function (status) {
        var _this = this;
        if (this.formData.from_system == 5 && status == 1) {
            var goodsTableData = Array.isArray(this.goodsTableData) ? this.goodsTableData : [];
            var purchaseOrderList = Array.isArray(this.formData.purchase_order_order) ? this.formData.purchase_order_order : [];
            var orderInfo = '';
            var isMoneyNegative_1 = false;
            if (this.shipData) {
                var orders = purchaseOrderList.map(function (v) { return v.order_code; }).join('，');
                orderInfo = "\u8BA2\u8D27\u5355\u53F7\uFF1A" + orders;
            }
            else {
                orderInfo = "\u9001\u8D27\u5355\u53F7\uFF1A" + this.formData.delivery_order_code;
            }
            goodsTableData.map(function (v) {
                if (Number(v.order_detail_money) < 0) {
                    isMoneyNegative_1 = true;
                }
                return v;
            });
            if (isMoneyNegative_1) {
                this.$confirm(orderInfo + "\u4E2D\u5B58\u5728\u5B9E\u4ED8\u91D1\u989D\u4E3A\u8D1F\u6570\u7684\u8D27\u54C1\uFF0C\u53D1\u8D27\u540E\u4E0D\u53EF\u4FEE\u6539\uFF0C\u786E\u8BA4\u53D1\u8D27\u4E48\uFF1F").then(function () {
                    _this.handleDeliveryOrder(status);
                }, function (err) { });
            }
            else {
                this.handleDeliveryOrder(status);
            }
        }
        else {
            this.handleDeliveryOrder(status);
        }
    };
    default_1.prototype.handleDeliveryOrder = function (status) {
        var _this = this;
        var params = {
            delivery_order_id: this.order_id,
            organ_id: this.formData.organ_id,
            out_depot_id: this.formData.out_depot_id,
            expect_arrivedate: this.formData.expect_arrivedate ? moment(this.formData.expect_arrivedate).format('YYYY-MM-DD') : this.formData.expect_arrivedate,
            reciever_phone: this.formData.reciever_phone,
            deliverer_id: this.formData.deliverer_id,
            delivery_time: this.formData.delivery_time
                ? moment(this.formData.delivery_time).format('YYYY-MM-DD HH:mm:ss')
                : '',
            order_icomment: this.formData.order_icomment,
            delivery_order_status: status,
            data: JSON.stringify(this.goodsTableData),
        };
        var bindUpdateOrderAjax = function (params) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.deliverService.updateDeliveryOrder(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 0) {
                    _this.$message.success('操作成功');
                    setTimeout(function () {
                        GLOBAL_VUE.$emit('closeTab', _this);
                        _this.opener.search();
                    }, 500);
                    return;
                }
                if (res.data.code === 67) {
                    var text = res.data.msg.split('？');
                    var confirmText = [text[0] + '？', text[1]];
                    var newDatas = [];
                    var h = _this.$createElement;
                    for (var i in confirmText) {
                        newDatas.push(h('p', null, confirmText[i]));
                    }
                    _this.$confirm('提示', {
                        title: '提示',
                        message: h('div', null, newDatas),
                        confirmButtonText: "是",
                        cancelButtonText: "否",
                        type: "success",
                        showClose: false,
                    }).then(function (res) {
                        if (res) {
                            bindUpdateOrderAjax(__assign({}, params, { split_confirm: 1 }));
                            return;
                        }
                    }).catch(function (action) {
                        if (action === "cancel") {
                            bindUpdateOrderAjax(__assign({}, params, { split_confirm: 0 }));
                        }
                    });
                    return;
                }
                if (res.data.code === 54) {
                    var instance_1 = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    instance_1.$on('artMsglist:ok', function (data) {
                        var confirm = res.data.data[0].confirm;
                        bindUpdateOrderAjax(__assign({}, params, { confirm: confirm }));
                    });
                    return;
                }
                if (res.data.code === 17) {
                    var instance_2 = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                            txtColor: "#FF2605"
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    instance_2.$on('artMsglist:ok', function (data) {
                        bindUpdateOrderAjax(__assign({}, params, { stock_confirm: 1 }));
                    });
                    return;
                }
                var instance = _this.$dialog(ArticleList, {
                    data: {
                        resData: res.data,
                        modelType: 'deliver'
                    },
                }, {
                    title: '提示',
                    width: 450,
                    height: 350,
                    closeBtn: false,
                }).instance;
                instance.$on('addClient:ok', function (data) {
                    if (res.data.code == EPurOrderErrorCode.BUSINESS_GOODS_NOT_BIND) {
                        _this.addTab({
                            component: Client,
                            title: '合作客户',
                            name: '合作客户'
                        });
                    }
                    if (res.data.code == EPurOrderErrorCode.GOODS_STOCK_IS_SHORT) {
                        _this.addTab({
                            component: Purchase,
                            title: '采购入库',
                            name: '采购入库'
                        });
                    }
                });
            })
                .catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance.close();
            });
        };
        bindUpdateOrderAjax(params);
    };
    default_1.prototype.getSelectIds = function () {
        var orderIds = this.selections.map(function (item) {
            return item.order_id;
        });
        return orderIds;
    };
    default_1.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = this.isShowPrice ? ['order_detail_goods_money', 'order_detail_tax_money', 'order_detail_money', 'money', 'order_detail_reduction_money'] : [];
        sums = summaries(param, showSum);
        sums[0] = '合计';
        console.log('getSummaries>>>', sums);
        return sums;
    };
    default_1.prototype.addGoods = function () {
        var _this = this;
        try {
            this.validateAddGood(this.formData);
        }
        catch (err) {
            this.$message.warning(err.message);
            return;
        }
        var goodIds = [];
        this.goodsTableData.forEach(function (item) {
            if (_this.formData.order_type == EOrderType.NO_ORDER) {
                goodIds.push(item.goods_format_id);
            }
            else if (_this.formData.order_type == EOrderType.RETAIL) {
                goodIds.push(item.goods_format_id);
            }
        });
        var instance = this.$dialog(DistriDialog, {
            data: {
                supplier_upper_id: 1,
                formData: this.formData,
                openedCodeData: this.openedCodeData,
                selectedGoodIds: goodIds,
            },
        }, {
            title: '添加货品',
            width: 750,
            height: 650,
        }).instance;
        instance.$on('save:ok', function (selectGood) {
            if (selectGood.length) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                var goods_ids = selectGood.map(function (item) { return item.supplier_goods_id; });
                _this.basicArcheivesService
                    .getDepotId({
                    organ_id: _this.formData.organ_id,
                    shop_id: _this.formData.shop_id,
                    goods_ids: goods_ids.join(','),
                })
                    .then(function (res) {
                    loadingInstance_1.close();
                    var data = res.data.data;
                    var ruleOutDepotIds = data && data.goods_depot_map;
                    selectGood.forEach(function (item) {
                        item.supplier_goods_format = item.supplier_goods_format || item.goods_format_name;
                        var ruleOutDepotId = ruleOutDepotIds[item.supplier_goods_id];
                        if (ruleOutDepotId && ruleOutDepotId.depot_id) {
                            item.out_depot_id = ruleOutDepotId.depot_id;
                            item.out_depot_name = ruleOutDepotId.depot_name;
                        }
                        _this.goodsTableData.push(item);
                        _this.getOutDepotOptionsOneOrZero(item);
                    });
                })
                    .catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                    loadingInstance_1.close();
                });
            }
        });
    };
    default_1.prototype.getRowClassName = function (_a) {
        var row = _a.row;
        return row.isChild ? 'is-child' : '';
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品');
            return;
        }
        this.$confirm('请确认是否删除该货品', '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.goodsTableData.indexOf(item);
                _this.goodsTableData.splice(index, 1);
            });
        }, function (err) { });
    };
    default_1.prototype.validateSaveDeliver = function (data) {
        if (!data.order_type && data.order_type !== 0) {
            throw new Error('请选择单据类型');
            return;
        }
        if (!data.organ_id && data.organ_id !== 0) {
            throw new Error('请选择出库机构');
            return;
        }
        if (!data.out_depot_id && data.out_depot_id !== 0) {
            throw new Error('出库机构没有设置默认仓库');
            return;
        }
        if (!data.business_id && data.business_id !== 0) {
            throw new Error('请选择收货机构');
            return;
        }
        if (!data.expect_arrivedate) {
            throw new Error('请选择预计收货时间');
            return;
        }
    };
    default_1.prototype.validateAddGood = function (data) {
        if (!data.order_type && data.order_type !== 0) {
            throw new Error('请选择单据类型');
            return;
        }
        if (!data.out_depot_id && data.out_depot_id !== 0) {
            throw new Error('出库机构没有设置默认仓库');
            return;
        }
        if (!data.business_id && data.business_id !== 0) {
            throw new Error('请选择收货机构');
            return;
        }
    };
    default_1.prototype.seeBindLicenses = function (row) {
        GLOBAL_VUE.$emit('addTab', {
            component: SeeBindLicenses,
            opener: this,
            title: '查看证照',
            showExist: true,
            name: 'goods-see-bind-license' +
                row.supplier_goods_id +
                'goods_format_id' +
                row.goods_format_id +
                'order_id' +
                this.order_id +
                'order_detail_id' +
                row.order_detail_id,
            cprops: {
                from_page: 'deliver',
                order_id: this.formData.order_id,
                order_detail_id: row.order_detail_id,
                goods_id: row.supplier_goods_id,
                goods_name: row.supplier_goods_name,
                goods_code: row.supplier_goods_code,
                goods_format_id: row.goods_format_id,
                goods_format_name: row.supplier_goods_format,
                delivery_order_status: this.formData.delivery_order_status,
                is_edit_order_document: row.is_edit_order_document,
                business_id: this.formData.business_id,
            },
        });
    };
    default_1.prototype.addTab = function (options) {
        options.opener = this;
        options.showExist = true,
            GLOBAL_VUE.$emit('addTab', options);
    };
    default_1.prototype.loadChildren = function (row, treeNode, resolve) {
        resolve(row.children || []);
    };
    default_1.prototype.replaceGood = function (oldrow, index) {
        var _this = this;
        var rowData = oldrow;
        var dialog = this.$dialog(addGoods, {
            data: {
                formData: this.formData,
                target: rowData,
                addedDatas: rowData.children && rowData.children.length ? [rowData.children[0]] : []
            },
        }, {
            title: "绑定替换货品",
            width: 950,
            height: 600,
            zIndex: 3000,
        });
        dialog.instance.$on("save:ok", function (row) {
            var copyRow = _.cloneDeep(row[0]);
            var copyData = _.cloneDeep(_this.goodsTableData[index]);
            copyRow.supplier_goods_format = copyRow.goods_format_name;
            copyRow.order_detail_oamount = oldrow.order_detail_oamount;
            copyRow.outDepotOptions = oldrow.outDepotOptions;
            copyRow.order_detail_goods_money = numMulti(oldrow.order_detail_oamount, copyRow.order_detail_uprice);
            _this.$message.success('货品绑定成功！');
            copyRow.order = index;
            copyRow.isChild = true;
            copyData.children = [];
            copyData.children.push(copyRow);
            copyData.order_goods_replace_map = copyRow;
            copyData.replace_supplier_goods_name = copyRow.supplier_goods_name;
            _this.goodsTableData.splice(index, 1, copyData);
            console.log(555, _this.goodsTableData, _this.computedGoodsTableData);
        });
    };
    default_1.prototype.delReplaceGood = function (row) {
        var order = row.order;
        var index = this.goodsTableData.findIndex(function (item, index) {
            return item.children[0] && item.children[0].order == order;
        });
        this.$message.success('货品绑定删除成功');
        this.goodsTableData[index].children = [];
        this.goodsTableData[index].order_goods_replace_map = [];
        this.goodsTableData[index].replace_supplier_goods_name = '';
        this.$forceUpdate();
    };
    default_1.prototype.cellClass = function (row) {
    };
    __decorate([
        Prop({
            type: Object,
            default: function () { }
        })
    ], default_1.prototype, "shopInfo", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; }
        })
    ], default_1.prototype, "data", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () { }
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 1
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 2
        })
    ], default_1.prototype, "is_open_goods_replace", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], default_1.prototype, "is_open_purchase_price", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () {
                return { outStoreList: [] };
            }
        })
    ], default_1.prototype, "otherData", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'goods'
        })
    ], default_1.prototype, "tabType", void 0);
    __decorate([
        Watch('data', { deep: true })
    ], default_1.prototype, "dataChange", null);
    default_1 = __decorate([
        Component({
            components: {},
            computed: __assign({}, mapGetters({
                user: 'user',
                isErp: 'isErp',
                openedCodeData: 'openedCodeData',
                ediStatus: 'ediStatus',
                canSelectBatch: 'canSelectBatch',
            }), { isHideGiftAmount: function () {
                    var billData = this.formData || {};
                    return (billData.logistics_type === 2 && billData.depot_in_model === 1) ||
                        [4, 5].includes(billData.logistics_type);
                },
                computedGoodsTableData: function () {
                    var list = this.goodsTableData || [];
                    return list.map(function (item, index) {
                        item.isIndex = true;
                        item.parentIndex = index + 1;
                        item.rowKey = _.uniqueId() + "__" + item.goods_format_id;
                        item.hasChildren = item.children && item.children.length ? true : false;
                        if (item.hasChildren) {
                            item.children.forEach(function (child) {
                                child.rowKey = _.uniqueId() + "__" + child.goods_format_id;
                            });
                        }
                        return item;
                    });
                },
                through_is_show_uprice: function () {
                    if (this.handleStatus === EHandleStatus.Add) {
                        return true;
                    }
                    var isVirtualStraight = [4, 5].includes(this.formData.logistics_type);
                    return (isVirtualStraight && this.formData.vir_through_is_show_uprice == 1 && this.handleStatus === EHandleStatus.Edit);
                },
                isShowPrice: function () {
                    if (this.handleStatus === EHandleStatus.Add) {
                        return true;
                    }
                    var isVirtualStraight = [4, 5].includes(this.formData.logistics_type);
                    return (!isVirtualStraight && this.handleStatus === EHandleStatus.Edit && this.formData.is_show_uprice == 1);
                },
                amountScale: function () {
                    return this.$store.getters.getBusinessConfig(this.formData.business_id, 'amount_scale', '4');
                } }),
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
